/* global jQuery */

export default function SUPostsGridShortcode () {
  /*! <fs__only> */
  jQuery(function ($) {
    $(document).on('click', '.sue-posts-grid-ajax .sue-posts-grid-pagination a', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which === 2) {
        return
      }

      var link = this
      var $grid = $(link).closest('.sue-posts-grid')
      var ajaxUrl = $grid.attr('data-ajax-url')
      var nonce = $grid.attr('data-nonce')
      var atts = $grid.attr('data-atts')

      if (!ajaxUrl || !nonce || !atts) {
        return
      }

      e.preventDefault()

      if ($grid.hasClass('sue-posts-grid-loading')) {
        return
      }

      $grid
        .addClass('sue-posts-grid-loading')
        .attr('aria-busy', 'true')

      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'su_posts_grid_paginate',
          nonce: nonce,
          atts: atts,
          page: getPageFromUrl(link.href, $grid.attr('data-page-key')),
          url: link.href
        }
      })
        .done(function (response) {
          if (!response || !response.success || !response.data || !response.data.html) {
            window.location.href = link.href
            return
          }

          $grid.replaceWith(response.data.html)
        })
        .fail(function () {
          window.location.href = link.href
        })
        .always(function () {
          $grid
            .removeClass('sue-posts-grid-loading')
            .removeAttr('aria-busy')
        })
    })
  })
  /*! </fs__only> */
}

function getPageFromUrl (url, key) {
  if (!key) {
    return 1
  }

  var link = document.createElement('a')
  link.href = url

  if (!link.search) {
    return 1
  }

  var query = link.search.substring(1).split('&')

  for (var index = 0; index < query.length; index++) {
    var pair = query[index].split('=')

    if (decodeURIComponent(pair[0]) === key) {
      return parseInt(decodeURIComponent(pair[1] || '1'), 10) || 1
    }
  }

  return 1
}
